
import Config from "../config";
import {ActionModel} from '../models/models';

export type ActionResponseType = {activeComponentData: any | {},
                                  selectedAction: ActionModel,
                                  successMessage: string | null,
                                  celebrations: []}

export const performDownloadAction =
        async (thisAction: ActionModel,
               objectApiName: string | null,
               recordUuid: string | null,
               authToken: string) : Promise<string> => {

    const actionUuid = thisAction.Uuid_sys;

    try {
      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/x/action/${actionUuid}/${objectApiName}/${recordUuid}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/pdf, application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
          method: "GET",
          headers: headers,
        })

        if(!response.ok) {
          const errorData = await response.json();
          if(!errorData.message){
            throw new Error("Unhandled error when performing action");
          } else{
            throw new Error(errorData.message);
          }
        }

        const filename = response.headers.get('crm-filename') || 'my_file';
        const this_blob = await response.blob();
        const downloadURL = window.URL.createObjectURL(this_blob);
        let a = document.createElement('a');
        a.href = downloadURL;
        a.download = filename;
        a.click();
        a.remove();

        return filename

    } catch (error) {
      throw new Error(`${(error as Error).message}`)
    }
  };




export const performAction = async (thisAction: ActionModel,
                                    objectApiName: string | null,
                                    recordUuid: string | null,
                                    authToken: string) : Promise<ActionResponseType> => {
    const actionUuid = thisAction.Uuid_sys;

    try {

        //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/x/action/${actionUuid}/${objectApiName}/${recordUuid}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
          method: "GET",
          headers: headers,
        })

        if(!response.ok) {
          const errorData = await response.json();
          if(!errorData.message){
            throw new Error("Error when fetching records");
          } else{
            throw new Error(errorData.message);
          }
        }

        const data = await response.json();
        if(!data){
          throw new Error("Error when fetching data");
        }

        const thisPromise: ActionResponseType = {activeComponentData: {},
                                                 selectedAction: thisAction,
                                                 successMessage: null,
                                                 celebrations: []}

        if(thisAction.OnSuccess_sys.type==='snackbar'){
          if(data?.message) thisPromise.successMessage = `${data.message}`;
          if(!data?.message) thisPromise.successMessage = 'Action submitted'
        }

        if(thisAction.OnSuccess_sys.type==='flow'){
          if(data.status==='ok'){
            //flow already succeeded (no screen)
            thisPromise.successMessage = `${data.message}`;
          }
        }

        thisPromise.activeComponentData = data

        return thisPromise

    } catch (error){
      throw new Error(`${(error as Error).message}`)
    }

  }


export const redirectApiLink = async (thisAction: ActionModel,
                                      objectApiName: string | null,
                                      recordUuid: string | null,
                                      authToken: string) : Promise<ActionResponseType> => {

    if(!recordUuid){
      throw Error("Error in redirectApiLink: recordUuid not defined")
    }

    try {

      const endpointPath = thisAction.EndpointUrl_sys.replace('-{recordUuid}-',recordUuid);
      const url = `${Config.getInstance().getCoordinationServiceURL()}${endpointPath}`;

      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
          method: "GET",
          headers: headers,
        })

        if(!response.ok) {
          const errorData = await response.json();
          if(!errorData.message){
            throw new Error("Error when fetching records");
          } else{
            throw new Error(errorData.message);
          }
        }

        const data = await response.json();
        if(!data){
          throw new Error("Error when fetching data");
        }

        const thisPromise : ActionResponseType = {activeComponentData: {},
                                                  selectedAction: thisAction,
                                                  successMessage: null,
                                                  celebrations: []}

        if(thisAction.OnSuccess_sys.type ==='snackbar'){
          thisPromise.successMessage = "Action performed successfully";
        }

        return thisPromise

    } catch (error){
      throw new Error(`${(error as Error).message}`)
    }

  }
